module.exports = __webpack_public_path__ + "static/media/Redo.b12aefae.svg";